import { inject, Injectable } from '@angular/core';

import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Platform } from '@ionic/angular';
import { Store } from '@ngrx/store';

import * as fromLayoutActions from '../../store/actions/layout.actions';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private store = inject(Store);
  private platform = inject(Platform);

  async init() {
    this.store.dispatch(
      fromLayoutActions.updateUseMobileLayout({
        payload: {
          useMobileLayout: Capacitor.isNativePlatform()
        }
      })
    );

    if (Capacitor.isNativePlatform() && this.platform.is('android')) {
      await StatusBar.setStyle({ style: Style.Light });
    }
  }
}
